<button class="btn btn-primary" [disabled]="isLoading" (click)="onClick($event)">
    <span *ngIf="isLoading">Loading</span>
    <ng-content></ng-content>
</button>
